// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenToy_text__2aIyo","name":"OpenToy_name__2zqFH","contentButton":"OpenToy_contentButton__DJNLf","content":"OpenToy_content__24sEH"};